export default {
  article: () => import("/var/www/vuejsexamples/nuxt/src/layouts/article.vue").then(m => m.default || m),
  default: () => import("/var/www/vuejsexamples/nuxt/src/layouts/default.vue").then(m => m.default || m),
  dusk: () => import("/var/www/vuejsexamples/nuxt/src/layouts/dusk.vue").then(m => m.default || m),
  error: () => import("/var/www/vuejsexamples/nuxt/src/layouts/error.vue").then(m => m.default || m)
}